import { useState, useEffect } from 'react';
import { getPageContent } from '../services/pageContentService';

/**
 * Custom hook to fetch page content from Firestore
 * @param {string} pageId - Page identifier
 * @param {string} sectionId - Section identifier
 * @param {Object} defaults - Default values to use if content not found
 * @returns {Object} { content, loading, error }
 */
export const usePageContent = (pageId, sectionId, defaults = {}) => {
  const [content, setContent] = useState(defaults);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const data = await getPageContent(pageId, sectionId);
        
        if (data) {
          // Merge with defaults to ensure all fields exist
          setContent({ ...defaults, ...data });
        } else {
          // Use defaults if no content found
          setContent(defaults);
        }
      } catch (err) {
        console.error('Error loading page content:', err);
        setError(err);
        // Use defaults on error
        setContent(defaults);
      } finally {
        setLoading(false);
      }
    };

    if (pageId && sectionId) {
      loadContent();
    } else {
      setContent(defaults);
      setLoading(false);
    }
  }, [pageId, sectionId]);

  return { content, loading, error };
};


